module.exports = __webpack_public_path__ + "img/UtilityTabRollover_ua.95686964.webp";